// extracted by mini-css-extract-plugin
export default {"loader":"FullSpaseLoader_loader__eyUHe","loaderNot":"FullSpaseLoader_loaderNot__LWfvn"};